import { PREVIEW_ACCOUNT_ROWS_SESSION_KEY } from './keys.js'

const DEMO_SUMMARY_LINES = [
  '3 threads need a reply',
  'Meeting follow-up due today',
  'Invoice approval waiting',
]

export function readPreviewAccountRowsFromSession() {
  if (typeof sessionStorage === 'undefined') return []
  try {
    const raw = sessionStorage.getItem(PREVIEW_ACCOUNT_ROWS_SESSION_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed.filter((row) => row && typeof row === 'object' && typeof row.id === 'string')
  } catch {
    return []
  }
}

function dedupeAccountsById(rows) {
  const seen = new Set()
  const out = []
  for (const row of rows) {
    const id = String(row?.id ?? '').trim()
    if (!id || seen.has(id)) continue
    seen.add(id)
    out.push(row)
  }
  return out
}

export function readEstablishedConnectionAccountRowsFromSession() {
  return dedupeAccountsById(readPreviewAccountRowsFromSession())
}

export function appendPreviewAccountRowForSlug(toolkitSlug) {
  if (typeof sessionStorage === 'undefined') return
  const slug = String(toolkitSlug || '').trim().toLowerCase()
  if (!slug) return
  try {
    const rows = readPreviewAccountRowsFromSession()
    const n = rows.filter((r) => String(r.toolkitSlug || '').toLowerCase() === slug).length + 1
    const domain = slug === 'outlook' ? 'outlook.office365.com' : 'gmail.com'
    rows.push({
      id: `preview-${slug}-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
      toolkitSlug: slug,
      email: `mailbox.${slug}.${n}@${domain}`,
      summary: DEMO_SUMMARY_LINES[rows.length % DEMO_SUMMARY_LINES.length],
      estimatedMinutes: 10,
      reply: { label: 'Reply' },
    })
    sessionStorage.setItem(PREVIEW_ACCOUNT_ROWS_SESSION_KEY, JSON.stringify(rows))
  } catch {
    /* quota */
  }
}
